import { Component } from '@angular/core';
import { membersuiteOrganizationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Organizations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteorganization-form',
    templateUrl: './membersuiteorganization.form.component.html'
})
export class membersuiteOrganizationFormComponent extends BaseFormComponent {
    public record!: membersuiteOrganizationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

